import * as React from 'react';

import { useRegion } from 'common/hooks/region';
import { usePermissions } from 'utils/permissions';
import { useUserContext } from 'common/contexts/UserContext';
import { getLandingMenu } from './menus';
import { CategoryGroup } from './Group';

export const Menu = () => {
  const region = useRegion();
  const permissions = usePermissions();
  const { user } = useUserContext();
  const items = React.useMemo(
    () => getLandingMenu(region, permissions, user),
    [region, permissions, user]
  );

  const renderedItems = items.map((category) => (
    <CategoryGroup region={region} category={category} key={category.title} />
  ));

  return (
    <div className="pt-2 grid grid-cols-1 md:grid-cols-2 gap-x-32 gap-y-12">{renderedItems}</div>
  );
};
